export const NAME = 'modal';

// Modal state
export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';

// Modal type
export const MODAL_TYPE_REGISTER = 'MODAL_TYPE_REGISTER';
export const MODAL_TYPE_LOGIN = 'MODAL_TYPE_LOGIN';
export const MODAL_TYPE_LOGIN_FAILED = 'MODAL_TYPE_LOGIN_FAILED';
export const MODAL_TYPE_STAGING_LOGIN = 'MODAL_TYPE_STAGING_LOGIN';
export const MODAL_TYPE_LOGGED_OUT = 'MODAL_TYPE_LOGGED_OUT';
export const MODAL_TYPE_INTERSTITIEL = 'MODAL_TYPE_INTERSTITIEL';
export const MODAL_TYPE_ADBLOCKER = 'MODAL_TYPE_ADBLOCKER';
export const MODAL_TYPE_INFORMATIVE = 'MODAL_TYPE_INFORMATIVE';
export const MODAL_TYPE_ALO_DELETE_ACCOUNT = 'MODAL_TYPE_ALO_DELETE_ACCOUNT';
export const MODAL_TYPE_ALO_REACTIVATE_ACCOUNT = 'MODAL_TYPE_ALO_REACTIVATE_ACCOUNT';
export const MODAL_TYPE_ENROLL = 'MODAL_TYPE_ENROLL';
export const MODAL_TYPE_DISENROL = 'MODAL_TYPE_DISENROL';
export const MODAL_TYPE_DELETE_IBAN = 'MODAL_TYPE_DELETE_IBAN';
export const MODAL_TYPE_GIVEAWAY = 'MODAL_TYPE_GIVEAWAY';
export const MODAL_TYPE_GIVEAWAY_END = 'MODAL_TYPE_GIVEAWAY_END';
export const MODAL_TYPE_TREES_PAYMENT_MODAL = 'MODAL_TYPE_TREES_PAYMENT_MODAL';
export const MODAL_TYPE_KYC = 'MODAL_TYPE_KYC';



// WEBPACK FOOTER //
// ./src/services/modal/constants.js